import { render, staticRenderFns } from "./manual-event-create.vue?vue&type=template&id=045f93dc&scoped=true&"
import script from "./manual-event-create.vue?vue&type=script&lang=js&"
export * from "./manual-event-create.vue?vue&type=script&lang=js&"
import style0 from "./manual-event-create.vue?vue&type=style&index=0&id=045f93dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045f93dc",
  null
  
)

export default component.exports